import { defineComponent as _defineComponent } from 'vue'
import { useConfigStore } from '@gms/stores/src/stores/config';
import { useThemeStore } from '@gms/stores/src/stores/theme';
import { AllThemes } from '../../../vuetify2-themes/dist';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookNParkDevtoolsPanel',
  setup(__props) {

const themeStore = useThemeStore();
const configStore = useConfigStore();

return { __sfc: true,themeStore, configStore, AllThemes }
}

})